import React, { useState, useEffect } from "react";
import { Divider, Stack, Typography, Button } from "@mui/material";
import LoadingButton from '@mui/lab/LoadingButton';
// COMPONENTS
// import { FormFieldWrapper } from '../components/FormFieldWrapper';
import { StyledInput } from '../components/StyledInput';
import { allStateOptions } from "./FormData";
import FormSectionHeader from '../components/FormSectionHeader';
import useWindowDimensions from '../hooks/useWindowDimensions';


const PaymentForm = ({ formik, handleSubmit, paymentInProgress, handleBack }) => {
  const { width: displayWidth, mobileVersion } = useWindowDimensions();

  return (
      <Stack direction="column" spacing={3} sx={{
        width: "100%", justifyContent: "flex-start",
        alignItems: "flex-start"
      }} role="form" aria-label="Payment Form">
        {/*********************************************  CARD DETAILS *********************************************/}
        <FormSectionHeader title="Card details" />

        <StyledInput name={'cardNumber'} label={`Card number`} formData={formik} width={'100%'} ariaLabel="Card Number" ariaRequired="true" />
        <StyledInput name={'cardName'} label={`Card holder's name`} formData={formik} width={'100%'} ariaLabel="Card Holder's Name" ariaRequired="true" />

        <Stack direction="row" spacing={0} sx={{ width: "100%", justifyContent: "space-between" }}>
          <StyledInput name={'expiryMonth'} label={'Expiry month'} placeholder={'MM'} formData={formik} width={'30%'} ariaLabel="Expiry Month" ariaRequired="true" />
          <StyledInput name={'expiryYear'} label={'Expiry year'} placeholder={'YYYY'} formData={formik} width={'30%'} ariaLabel="Expiry Year" ariaRequired="true" />
          <StyledInput name={'cvn'} label={'CVN'} formData={formik} width={'30%'} ariaLabel="Card Verification Number" ariaRequired="true" />
        </Stack>

                {/*********************************************  CARD DETAILS *********************************************/}

        <FormSectionHeader title="Billing details" />

        <StyledInput name={'billingAddress'} label={`Billing address`} formData={formik} width={'100%'} ariaLabel="Billing Address" ariaRequired="true" />

        <Stack direction="row" spacing={0} sx={{ width: "100%", justifyContent: "space-between"}}>
          <StyledInput name={'billingSuburb'} label={'Suburb'} formData={formik} width={'45%'} ariaLabel="Billing Suburb" ariaRequired="true" />
          <StyledInput name={'billingPostcode'} label={'Postcode'} formData={formik} width={'45%'} ariaLabel="Billing Postcode" ariaRequired="true" />
        </Stack>

        <Stack direction="row" spacing={0} sx={{ width: "100%", justifyContent: "space-between" }}>
          <StyledInput name={'billingState'} label={'State'} options={allStateOptions} formData={formik} width={'45%'} ariaLabel="Billing State" ariaRequired="true" />
          <StyledInput name={'billingCountry'} label={'Country'} formData={formik} width={'45%'} ariaLabel="Billing Country" ariaRequired="true" />
        </Stack>

        <Stack direction="row" spacing={0} sx={{ width: "100%", justifyContent: "space-between", paddingTop: '20px' }}>
        <LoadingButton color="secondary" variant="contained" sx={{ width: mobileVersion ? "48%" : "30%", color: 'white' }} onClick={handleSubmit} loading={paymentInProgress} aria-label="Submit Payment">
          Pay Now
        </LoadingButton>
          <Button 
            variant="contained" 
            sx={{ 
              width: mobileVersion ? "48%" : "30%", 
              backgroundColor: 'white',
              color: "#004677",
              '&:hover': {
                backgroundColor: '#f5f5f5',
              }
            }} 
            onClick={handleBack} 
            aria-label="Go Back"
          >
            Back
          </Button>

        </Stack>
        
      </Stack>
  );
};

export default PaymentForm;
